import { PrintingServiceRepository } from '../../../api/printingService/repository/printingService.repository';
import { PrintingServiceDao } from '../../../api/printingService/dao/printingService.dao';
import {
  PrintingService,
  PrintingServiceList,
  ResponsePrintingServiceProps,
} from '../../../types/printingService/PrintingService';
import { PrintingServiceFormValues } from '../../../types/printingService/interfaces';
import {
  LIST_PRINTING_SERVICE,
  SHOW_PRINTING_SERVICE,
  DELETE_PRINTING_SERVICE,
  RESET_PRINTING_SERVICE_STATE,
  CREATE_PRINTING_SERVICE,
  UPDATE_PRINTING_SERVICE,
  PRINTING_SERVICE_LIST,
  TypesActionsPrintingService,
} from './PritingSeviceTypes';

function listPrintingService(
  payload: ResponsePrintingServiceProps
): TypesActionsPrintingService {
  return {
    type: LIST_PRINTING_SERVICE,
    payload,
  };
}

function showPrintingService(
  payload: PrintingService
): TypesActionsPrintingService {
  return {
    type: SHOW_PRINTING_SERVICE,
    payload,
  };
}

function createPrintingService(
  payload: PrintingService
): TypesActionsPrintingService {
  return {
    type: CREATE_PRINTING_SERVICE,
    payload,
  };
}

function updatePrintingService(
  payload: PrintingService
): TypesActionsPrintingService {
  return {
    type: UPDATE_PRINTING_SERVICE,
    payload,
  };
}

function deletePrintingService(payload: string): TypesActionsPrintingService {
  return {
    type: DELETE_PRINTING_SERVICE,
    payload,
  };
}

function printingServiceList(
  payload: PrintingServiceList[]
): TypesActionsPrintingService {
  return {
    type: PRINTING_SERVICE_LIST,
    payload,
  };
}

export function resetPrintingServiceState(): TypesActionsPrintingService {
  return {
    type: RESET_PRINTING_SERVICE_STATE,
  };
}

export function listPrintingServiceAsync(
  numberPage: number,
  limit: number,
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return async function (dispacth: Function) {
    const response = await PrintingServiceDao.listPrintingServices(
      accountId,
      numberPage,
      limit,
      search,
      filter
    );
    dispacth(listPrintingService(response.data));
  };
}

export function createPrintingServiceAsync(
  data: PrintingServiceFormValues,
  callbackSuccess?: Function,
  callbackError?: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await PrintingServiceRepository.createPrintingService(
        data
      );
      dispatch(createPrintingService(response.data));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess(response.data);
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError(error);
      }
    }
  };
}

export function showPrintingServiceAsync(
  id: string,
  accountId: string,
  callbackSuccess?: Function,
  callbackError?: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await PrintingServiceDao.showPrintingService(
        id,
        accountId
      );
      dispatch(showPrintingService(response.data));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess(response.data);
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError(error);
      }
    }
  };
}

export function updatePrintingServiceAsync(
  data: PrintingServiceFormValues,
  callbackSuccess?: Function,
  callbackError?: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await PrintingServiceRepository.updatePrintingService(
        data
      );
      dispatch(updatePrintingService(response.data));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess(response.data);
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError(error);
      }
    }
  };
}

export function deletePrintingServiceAsync(
  data: { id: string; accountId: string },
  callbackSuccess?: Function,
  callbackError?: Function
) {
  return async function (dispatch: Function) {
    try {
      await PrintingServiceRepository.deletePrintingService(
        data.id,
        data.accountId
      );
      dispatch(deletePrintingService(data.id));
      if (callbackSuccess && typeof callbackSuccess === 'function') {
        callbackSuccess();
      }
    } catch (error) {
      if (callbackError && typeof callbackError === 'function') {
        callbackError(error);
      }
    }
  };
}

export function printingServiceListAsync(accountId: string) {
  return async function (dispatch: Function) {
    try {
      const response = await PrintingServiceDao.printingServiceList(accountId);
      dispatch(printingServiceList(response.data));
    } catch (error) {
      console.error('Error fetching printing service list: ', error);
    }
  };
}
